import Workflowtabs from './workflowtabs.vue';
export default Workflowtabs;


// WEBPACK FOOTER //
// ./src/components/workflowtabs/index.js